import React, { useEffect } from 'react'

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getLogs } from '../../actions/logsActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Loader from '../../components/loaders/Loader'

export default function Logs() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {clientauth} = useAuth()

	const {logs, loading} = useSelector(state=>state.logs)

	useEffect(() => {
		if(clientauth){
			dispatch(getLogs())
		}
	},[dispatch, t, clientauth])

    const columnsLogs = [
        {
            name: t('admin.logs.date'),
            minWidth: '160px',
            cell: datos =>
                <div>
                    {Intl.DateTimeFormat('es-ES', {dateStyle: 'short', timeStyle: 'short', hourCycle: 'h23', timeZone: 'Europe/Madrid'}).format(new Date(datos.date))}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('admin.logs.user'),
            minWidth: '160px',
            cell: datos =>
                <div>
                    {datos.user ? (datos.user.email || datos.user.username) : '-'}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('admin.logs.action'),
            minWidth: '120px',
            cell: datos =>
                <div>
                    {datos.action || '-'}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('admin.logs.log'),
            minWidth: '300px',
            cell: datos =>
                <div>
                    {datos.message}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        }
    ]

	return (
        <>
            <div className="toolbar">
                <div className="toolbar-left">
                    <h4>{t('admin.dashboard.logs')}</h4>
                </div>
            </div>

            {loading ? (
                <Loader />
            ) : logs?.length > 0 ? (
                <div className="card-simple">
                    <CustomDataTable
                        columns={columnsLogs}
                        data={logs}
                        exportable={false}
                        printable={false}
                        filter={true}
                    />
                </div>
            ) : (
                <div className="empty-state">
                    <div className="empty-state-icon"><i className="fas fa-history"></i></div>
                    <div className="empty-state-text">{t('admin.logs.thereisnotlogs')}</div>
                </div>
            )}
        </>
	)
}